/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetUserCouponCodes200ResponseAllOfData } from './GetUserCouponCodes200ResponseAllOfData';
import {
    GetUserCouponCodes200ResponseAllOfDataFromJSON,
    GetUserCouponCodes200ResponseAllOfDataFromJSONTyped,
    GetUserCouponCodes200ResponseAllOfDataToJSON,
} from './GetUserCouponCodes200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetUserCouponCodes200ResponseAllOf
 */
export interface GetUserCouponCodes200ResponseAllOf {
    /**
     * 
     * @type {GetUserCouponCodes200ResponseAllOfData}
     * @memberof GetUserCouponCodes200ResponseAllOf
     */
    data: GetUserCouponCodes200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetUserCouponCodes200ResponseAllOf interface.
 */
export function instanceOfGetUserCouponCodes200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetUserCouponCodes200ResponseAllOfFromJSON(json: any): GetUserCouponCodes200ResponseAllOf {
    return GetUserCouponCodes200ResponseAllOfFromJSONTyped(json, false);
}

export function GetUserCouponCodes200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCouponCodes200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetUserCouponCodes200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetUserCouponCodes200ResponseAllOfToJSON(value?: GetUserCouponCodes200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetUserCouponCodes200ResponseAllOfDataToJSON(value.data),
    };
}

